import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { GlossaryItem, RegulatedGlossary } from "src/app/common/dto/glossary";

@Injectable({ providedIn: "root" })
export class JsonsService {
  private readonly http = inject(HttpClient);

  getGlossaries(): Observable<RegulatedGlossary> {
    return this.http
      .get<{
        moduleKnowledge: Array<GlossaryItem>;
        definitions: Array<GlossaryItem>;
      }>("/assets/jsons/glossary.json")
      .pipe(
        map(({ moduleKnowledge, definitions }) => new RegulatedGlossary(moduleKnowledge, definitions)),
        catchError(() => of(new RegulatedGlossary([], [])))
      );
  }

  getUpdateCycle(): Observable<Array<{ id: string; category: string; cycle: string }>> {
    return this.http
      .get<{ result: Array<{ id: string; category: string; cycle: string }> }>("/assets/jsons/update-cycle.json")
      .pipe(
        map(({ result }) => result),
        catchError(() => of([]))
      );
  }
}
